
import React from 'react';
import {
  Dialog,
  DialogHeader,
} from "@/components/ui/dialog";
import {
  EnhancedDialogContent,
  EnhancedDialogTitle,
  EnhancedDialogDescription
} from '@/lib/shadcn-wrappers';

interface SponsoredInfoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const SponsoredInfoDialog = ({ open, onOpenChange }: SponsoredInfoDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <EnhancedDialogContent>
        <DialogHeader>
          <EnhancedDialogTitle>Om annonsørinnhold</EnhancedDialogTitle>
          <EnhancedDialogDescription>
            Briefr er gratis for alle lesere. For Briefr er det avgjørende at verifisert kunnskap forblir gratis og tilgjengelig for alle. Som bruker trenger du derfor ikke abonnement hos oss. For å finansiere driften vår, samarbeider vi med utvalgte partnere som betaler for å formidle sin ekspertise. Artikkelen under er et slikt samarbeid, tydelig merket for å sikre full åpenhet.
          </EnhancedDialogDescription>
        </DialogHeader>
      </EnhancedDialogContent>
    </Dialog>
  );
};

export default SponsoredInfoDialog;
